/* Discgolf.ee 2.0 – tiny progressive enhancements (no dependencies, ~2 KB). */
(function () {
  'use strict';
  var LABELS = ['Kiirus', 'Hõljuvus', 'Pööre', 'Hajuvus'];

  function parseMoney(el) {
    if (!el) return 0;
    var t = (el.textContent || '').replace(/[^\d,.\-]/g, '').replace(/\.(?=\d{3}\b)/g, '').replace(',', '.');
    return parseFloat(t) || 0;
  }

  // USF cards: "5 | 4 | 0 | 2" -> four boxes (sibling element; Vue-owned nodes are never replaced),
  // "Allahindlus" -> "−X%". Re-checked on every USF re-render because Vue reuses card nodes.
  function enhanceCard(card) {
    var specs = card.querySelector('.indiv-product-specs:not(.dg-flight)');
    var src = specs ? specs.textContent.replace(/\u00a0/g, ' ').trim() : '';
    var box = card.querySelector('.dg-flight');
    if (specs && (!box || box.getAttribute('data-src') !== src)) {
      if (box) box.remove();
      var nums = src.split('|').map(function (s) { return s.trim(); }).filter(Boolean);
      if (nums.length >= 2) {
        var ul = document.createElement('ul');
        ul.className = 'dg-flight';
        ul.setAttribute('data-src', src);
        ul.setAttribute('aria-label', 'Lennunumbrid: ' + nums.join(', '));
        nums.slice(0, 4).forEach(function (n, i) {
          var li = document.createElement('li');
          li.innerHTML = '<span class="dg-flight__v"></span><span class="dg-flight__l">' + LABELS[i] + '</span>';
          li.firstChild.textContent = n;
          ul.appendChild(li);
        });
        specs.parentNode.insertBefore(ul, specs.nextSibling);
        specs.classList.add('dg-hide');
      } else {
        specs.classList.add('dg-hide');
      }
    }
    var badge = card.querySelector('.sale-badge');
    var price = card.querySelector('.money-styling');
    if (badge && price) {
      var cmp = parseMoney(price.querySelector('.compare-at-price .money'));
      var monies = price.querySelectorAll(':scope > .money');
      var now = parseMoney(monies[monies.length - 1]);
      var txt = cmp > now && now > 0 ? '\u2212' + Math.round((cmp - now) / cmp * 100) + '%' : null;
      if (txt && badge.textContent !== txt) badge.textContent = txt;
    }
  }

  function scan() {
    document.querySelectorAll('#usf_container .indiv-product-wrapper').forEach(enhanceCard);
  }

  function watchUSF() {
    if (!document.querySelector('[id^=usf_]') || !('MutationObserver' in window)) return;
    var pending = false;
    // USF (Vue) can swap #usf_container itself, so observe the main element.
    new MutationObserver(function () {
      if (pending) return; pending = true;
      requestAnimationFrame(function () { pending = false; scan(); });
    }).observe(document.getElementById('main') || document.body, { childList: true, subtree: true, characterData: true });
    scan();
  }

  // Product page: mobile sticky add-to-cart bar (mirrors the real button; no own cart logic)
  function stickyATC() {
    var btn = document.getElementById('purchase');
    if (!btn) return;
    var titleEl = document.querySelector('.product-description-header') || document.querySelector('#product-box h1, #product-box h2');
    var priceEl = document.getElementById('price-field');
    var bar = document.createElement('div');
    bar.className = 'dg-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="dg-sticky-atc__info"><div class="dg-sticky-atc__title"></div><div class="dg-sticky-atc__price"></div></div>' +
      '<button type="button" class="dg-btn" tabindex="-1"></button>';
    bar.querySelector('.dg-sticky-atc__title').textContent = titleEl ? titleEl.textContent.trim() : '';
    var bBtn = bar.querySelector('button');
    function sync() {
      bar.querySelector('.dg-sticky-atc__price').textContent = priceEl ? priceEl.textContent.replace(/Ostukorv Vahesumma/i, '').trim() : '';
      bBtn.textContent = btn.disabled ? (btn.textContent || '').trim() : 'Lisa ostukorvi';
      bBtn.disabled = !!btn.disabled;
    }
    bBtn.addEventListener('click', function () { btn.click(); });
    document.body.appendChild(bar);
    sync();
    if (priceEl) new MutationObserver(sync).observe(priceEl, { childList: true, subtree: true, characterData: true });
    new MutationObserver(sync).observe(btn, { attributes: true, childList: true, subtree: true });
    var ticking = false;
    function update() {
      ticking = false;
      var r = btn.getBoundingClientRect();
      bar.classList.toggle('is-visible', r.bottom < 0 && r.height > 0);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  function init() { watchUSF(); stickyATC(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
